var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isUser)?_c('home-user'):_c('home-admin')],1)}
var staticRenderFns = []

export { render, staticRenderFns }